import { createListFilters, IOption } from '../../../../components'

export type NotasVersaoFilters = {
  /** Texto livre: o backend busca no título e na versão. */
  titulo: string
  publicada?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<NotasVersaoFilters>({
  titulo: '',
  publicada: undefined,
})
